module.exports = __webpack_public_path__ + "img/Goals.98b92585.png";